import React, { FC, ReactElement } from 'react';

import styles from './styles.module.scss';

import { HeaderItemWithSorting } from 'components';

import { ITableHeaderWithSortingProps } from 'types/interfaces';

export const TableHeader: FC<ITableHeaderWithSortingProps> = ({
    sortedParamName,
    sortByParam,
}: ITableHeaderWithSortingProps): ReactElement => (
    <div className={styles.tableHeader}>
        <div className={styles.headerItems}>
            <div className={styles.rank}>
                <div>
                    <span>rank</span>
                </div>
            </div>
            <div className={styles.protocolInfo}>
                <div>
                    <span>protocol name & chain</span>
                </div>
            </div>
            <div className={styles.protocolType}>
                <div>
                    <span>protocol type</span>
                </div>
            </div>
            <div className={styles.currencyValue}>
                <HeaderItemWithSorting
                    sortByParam={sortByParam}
                    name="USD value / percentage"
                    sortedParamName={sortedParamName}
                    paramName={'usdValue'}
                />
            </div>
        </div>
    </div>
);
